import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moldSelect", "moldVariantSelect", "moldIdField"]
  static values = {
    moldVariants: Array
  }

  connect() {
    console.log("Wax melt form controller connected")
    
    // If editing an existing wax melt, populate the mold variants dropdown
    if (this.hasMoldSelectTarget) {
      const hasMoldSelected = this.moldSelectTarget.value
      if (hasMoldSelected) {
        this.updateMoldVariants()
      }
    }
  }

  updateMoldVariants() {
    const selectedMoldId = parseInt(this.moldSelectTarget.value)
    const moldVariantSelect = this.moldVariantSelectTarget
    const currentValue = moldVariantSelect.value

    // Update the hidden mold_id field
    const moldIdField = document.querySelector('[name="crafting_wax_melt[mold_id]"]')
    if (moldIdField) {
      moldIdField.value = selectedMoldId || ''
    }

    // Clear current options
    moldVariantSelect.innerHTML = '<option value="">Sélectionner une variante</option>'

    if (!selectedMoldId) {
      moldVariantSelect.disabled = true
      moldVariantSelect.innerHTML = '<option value="">Sélectionner un moule d\'abord</option>'
      return
    }

    // Filter mold variants by selected mold
    const filteredVariants = this.moldVariantsValue.filter(mv => mv.mold_id === selectedMoldId)

    if (filteredVariants.length === 0) {
      moldVariantSelect.disabled = true
      moldVariantSelect.innerHTML = '<option value="">Aucune variante disponible pour ce moule</option>'
      return
    }

    // Populate mold variant select
    filteredVariants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      moldVariantSelect.appendChild(option)
    })

    moldVariantSelect.disabled = false

    // Auto-select the first variant if there's only one and no current value
    if (filteredVariants.length === 1 && !currentValue) {
      moldVariantSelect.value = filteredVariants[0].id
    }
  }
}

